// SPDX-License-Identifier: AGPL-3.0-or-later

import {SettingsTabSection} from '@app/features/app/components/dialogs/shared/SettingsTabLayout';
import {AccountDeleteModal} from '@app/features/auth/components/modals/AccountDeleteModal';
import {AccountDisableModal} from '@app/features/auth/components/modals/AccountDisableModal';
import {GuildOwnershipWarningModal} from '@app/features/guild/components/modals/GuildOwnershipWarningModal';
import Guilds from '@app/features/guild/state/Guilds';
import {Button} from '@app/features/ui/button/Button';
import * as ModalCommands from '@app/features/ui/commands/ModalCommands';
import {modal} from '@app/features/ui/commands/ModalCommands';
import styles from '@app/features/user/components/modals/tabs/account_security_tab/AccountTab.module.css';
import type {User} from '@app/features/user/models/User';
import {Trans} from '@lingui/react/macro';
import {observer} from 'mobx-react-lite';
import type React from 'react';

interface DangerZoneTabProps {
	user: User;
	isClaimed: boolean;
}
export const DangerZoneTabContent: React.FC<DangerZoneTabProps> = observer(({user, isClaimed}) => {
	const handleDisableAccount = () => {
		ModalCommands.push(modal(() => <AccountDisableModal />));
	};
	const handleDeleteAccount = () => {
		const ownedGuilds = Guilds.getOwnedGuilds(user.id);
		if (ownedGuilds.length > 0) {
			ModalCommands.push(modal(() => <GuildOwnershipWarningModal ownedGuilds={ownedGuilds} />));
		} else {
			ModalCommands.push(modal(() => <AccountDeleteModal />));
		}
	};
	return (
		<>
			{isClaimed && (
				<SettingsTabSection
					title={<Trans>Disable Account</Trans>}
					description={<Trans>Temporarily disable your account. You can reactivate it later by signing back in.</Trans>}
				>
					<Button variant="danger-secondary" className={styles.claimButton} small={true} onClick={handleDisableAccount}>
						<Trans>Disable Account</Trans>
					</Button>
				</SettingsTabSection>
			)}
			<SettingsTabSection
				title={<Trans>Delete Account</Trans>}
				description={
					<Trans>Permanently delete your account and all associated data. This action cannot be undone.</Trans>
				}
			>
				<Button variant="danger-primary" className={styles.claimButton} small={true} onClick={handleDeleteAccount}>
					<Trans>Delete Account</Trans>
				</Button>
			</SettingsTabSection>
		</>
	);
});
